import { StyledTutorialKeys } from "../TutorialKeys.styled"
import { StyledTutorialSubTitle } from "../TutorialModal.styled"

const TutorialBasicsStep1 = () => {
  return (
    <StyledTutorialKeys>
      <div className="key-definition">
        <div className="tutorial-key arrow">←</div>
        <div className="key-action">Move left</div>
      </div>
      <div className="key-definition">
        <div className="tutorial-key arrow">→</div>
        <div className="key-action">Move right</div>
      </div>
      <div className="key-definition">
        <div className="key">
          <div className="tutorial-key long"><i>SPACE</i></div>
          <span className="">/</span>
          <div className="tutorial-key arrow">↑</div>
        </div>
        <div className="key-action">Jump (Up to 3 times)</div>
      </div>
    </StyledTutorialKeys>
  )
}

const TutorialBasicsStep2 = () => {
  return (
    <StyledTutorialKeys>
      <div className="key-definition">
        <div className="tutorial-key"><i>Q</i></div>
        <div className="key-action">LIGHT ATTACK(PUNCH)</div>
      </div>
      <div className="key-definition">
        <div className="tutorial-key"><i>W</i></div>
        <div className="key-action">BLOCK BUBBLE / SHIELD</div>
      </div>
      <div className="key-definition">
        <div className="tutorial-key"><i>E</i></div>
        <div className="key-action">MIDDLE ATTACK (KICK)</div>
      </div>
      <div className="key-definition">
        <div className="tutorial-key"><i>R</i></div>
        <div className="key-action">SUPER ATTACK (NEED 3+ COMBO POINTS)</div>
      </div>
      
    </StyledTutorialKeys>
  )
}

const TutorialBasicsStep3 = () => {
  return (
    <StyledTutorialKeys>
      <StyledTutorialSubTitle $fontType="text">
        DEPLETE YOUR OPPONENTS STRENGTH POINTS TO WIN!
      </StyledTutorialSubTitle>
      <div className="tutorial-stats">
        <img src='/assets/tutorial-stats.png' />
        <div className="stats-items">
          <div>HEALTH POINTS</div>
          <div>ATTACK POINTS</div>
          <div>DEFENSE POINTS</div>
          <div>SPEED</div>
          <div>CRITICAL HIT BOOST</div>
        </div>
      </div>
    </StyledTutorialKeys>
  )
}

export const TutorialBasics = ({ step }) => {
  switch (step) {
    case 0:
      return <TutorialBasicsStep1 />;
    case 1:
      return <TutorialBasicsStep2 />;
    case 2:
      return <TutorialBasicsStep3 />;
  }
};